module.exports = __webpack_public_path__ + "img/151.d21cc05b.jpg";